import React from 'react';

import { UpdatedField } from '../../typescript-types/employee-change-log';

import { EmployeeHistoryAssociationDetail } from './employee-history-association-detail';

import { employeeNameFromId } from '../../employees/utils/employee-name';

type InputProps = {
  changeHistoryId: number;
  supervisorChanges?: UpdatedField<Array<number>>;
  subordinateChanges?: UpdatedField<Array<number>>;
  employees: Array<Employee>;
};

export const EmployeeHistorySupervisorSubordinateDetail = ({
  changeHistoryId,
  supervisorChanges,
  subordinateChanges,
  employees,
}: InputProps) => {
  const getEmployeeNameById = (employeeId: number) => employeeNameFromId(employees, employeeId);

  return (
    <div>
      <EmployeeHistoryAssociationDetail
        changeHistoryId={changeHistoryId}
        newValue={supervisorChanges?.newValue || []}
        oldValue={supervisorChanges?.oldValue || []}
        associationLabel="supervisor"
        getAssociationNameById={getEmployeeNameById}
      />
      <EmployeeHistoryAssociationDetail
        changeHistoryId={changeHistoryId}
        newValue={subordinateChanges?.newValue || []}
        oldValue={subordinateChanges?.oldValue || []}
        associationLabel="direct report"
        getAssociationNameById={getEmployeeNameById}
      />
    </div>
  );
};
